import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import styled from "styled-components";
import { Localize } from "../../../../locale/localization";
import { rem } from "polished";
import HamburgerToggler from "./HamburgerToggler";
import { setDocumentClass } from "../../../../utils/ui-utils";
import PropTypes from "prop-types";

const bgBlue = `${process.env.PUBLIC_URL}/img/bg-blue.jpg`;

const NavWrapper = styled.nav`
  z-index: 100;
  opacity: 0;
  transition: opacity 0.125s ease-in;
  position: absolute;
  left:0px;
  top:0px;
  &.open {
    opacity: 1;
    width: 100%;
    height: 100%;
    background: url(${bgBlue});
    background-repeat: repeat-x;
    background-position: 0 0;
    background-size: cover;
  }

  ul {
    text-align: center;
    margin: 4rem auto 1rem auto;
    line-height: 3.5rem;
  }

  li {
    padding: 0 ${rem("5px")};
    display: block;
  }

  li a {
    color: white;
    font-family: FyranSans-Book;
    font-size: 1.75rem;

    &.active {
      font-family: FyranSans-SemiBold;
      color: #FF3334;
    }
  }
`;

const initialState = {
  open: false
};

class MobileNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  toggle = () => {
    const open = !this.state.open;
    this.setState(Object.assign({}, this.smtate, { open: open }));

    setDocumentClass("overlay", open);
  };

  close = () => {
    this.setState(Object.assign({}, this.state, { open: false }));

    setDocumentClass("overlay", false);
  };

  getClass = c => {
    if (this.state.open) {
      c += " open";
    }
    return c;
  };

  logout = () => {
    this.close();
    this.props.onLogoutClick();
  };

  render() {
    const { currentUser } = this.props;
    return (
      <div style={{display:'flex'}}>
        <HamburgerToggler open={this.state.open} onToggle={this.toggle} />
        <NavWrapper className={this.getClass("")}>
          {this.state.open && (
            <ul>
              <li>
                <NavLink to="/" exact onClick={this.close}>
                  {Localize("navi.root")}
                </NavLink>
              </li>
              <li>
                <NavLink to="/product-categories" onClick={this.close}>
                  {Localize("navi.products")}
                </NavLink>
              </li>
              {currentUser.hasAccessToPrizeProgram && (
                <li>
                  <NavLink to="/prizes" onClick={this.close}>
                    {Localize("navi.prizes")}
                  </NavLink>
                </li>
              )}
              {currentUser.hasAccessToAdmin && (
                <li>
                  <NavLink to="/admin" onClick={this.close}>
                    {Localize("navi.admin")}
                  </NavLink>
                </li>
              )}
              <li>
                <NavLink to="/profile" onClick={this.close}>
                  {Localize("navi.profile")}
                </NavLink>
              </li>
              <li>
                <a onClick={this.logout}>{Localize("navi.logout")}</a>
              </li>
            </ul>
          )}
        </NavWrapper>
      </div>
    );
  }
}

MobileNavigation.PropTypes = {
  onLogoutClick: PropTypes.func.isRequired
};

export default withRouter(MobileNavigation);



// WEBPACK FOOTER //
// ./src/modules/common/components/app/MobileNavigation.js